// import React from "react";

// export default function EMIBehaviorCards({ totalActiveLoans, stages, selectedMonth }) {
//   const cards = [
//     {
//       title: "Total Active Loans",
//       value: totalActiveLoans?.toLocaleString() || "0",
//       subtitle: "All EMI stages",
//       bg: "linear-gradient(135deg,#6A7282,#4b5563)",
//     },
//     ...(stages || []).map((stage) => ({
//       title: stage.stageLabel,
//       value: stage.activeLoans?.toLocaleString() || "0",
//       subtitle: `${stage.shareOfTotal?.toFixed(1) || 0}% of total`,
//       bg: stage.stageKey === 1
//         ? "linear-gradient(135deg,#2B7FFF,#155DFC)"
//         : stage.stageKey === 2
//         ? "linear-gradient(135deg,#00C950,#00A63E)"
//         : "linear-gradient(135deg,#F0B100,#D08700)",
//     })),
//   ];

//   return (
//     <div className="emi-behavior" style={{ marginTop: "40px" }}>
//       <div className="emi-behavior__header">
//         <h4
//           // className="emi-behavior__title"
//           style={{ color: "#0A0A0A", fontWeight: "600", fontSize: "20px" }}
//         >
//           EMI Behavior Tracking
//         </h4>

//         <p
//           className="emi-behavior__month"
//           style={{ color: "#4A5565", fontSize: "14px", fontWeight: "400" }}
//         >
//             {selectedMonth?.length > 0
//                 ? `Month: ${selectedMonth?.join(", ")}`
//                 : "No months selected"}
//         </p>
//       </div>

//       <div className="emi-behavior__grid">
//         {cards.map((card, index) => (
//           <div
//             key={index}
//             className="emi-behavior__card"
//             style={{ background: card.bg }}
//           >
//             <p className="emi-behavior__card-title">{card.title}</p>

//             <h4 className="emi-behavior__card-value">{card.value}</h4>

//             <p className="emi-behavior__card-subtitle">{card.subtitle}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import React from "react";

const shimmerCSS = `@keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}`;
const SkBox = ({ w, h, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: "6px",
    background: "linear-gradient(90deg,#ffffff33 25%,#ffffff55 50%,#ffffff33 75%)",
    backgroundSize: "600px 100%",
    animation: "shimmer 1.4s infinite linear",
    ...style,
  }} />
);

const SKELETON_COLORS = ["#6A7282", "#155DFC", "#00A63E", "#D08700"];

export default function EMIBehaviorCards({ totalActiveLoans, stages, selectedMonth, loading = false }) {
  const cards = [
    {
      title: "Total Active Loans",
      value: totalActiveLoans?.toLocaleString() || "0",
      subtitle: "All EMI stages",
      bg: "linear-gradient(135deg,#6A7282,#4b5563)",
    },
    ...(stages || []).map((stage) => ({
      title: stage.stageLabel,
      value: stage.activeLoans?.toLocaleString() || "0",
      subtitle: `${stage.shareOfTotal?.toFixed(1) || 0}% of total`,
      bg: stage.stageKey === 1
        ? "linear-gradient(135deg,#2B7FFF,#155DFC)"
        : stage.stageKey === 2
        ? "linear-gradient(135deg,#00C950,#00A63E)"
        : "linear-gradient(135deg,#F0B100,#D08700)",
    })),
  ];

  return (
    <>
      <style>{shimmerCSS}</style>
      <div className="emi-behavior" style={{ marginTop: "40px" }}>
        <div className="emi-behavior__header">
          {loading ? (
            <>
              <div style={{ width: "200px", height: "22px", borderRadius: "6px", background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)", backgroundSize: "600px 100%", animation: "shimmer 1.4s infinite linear", marginBottom: "8px" }} />
              <div style={{ width: "140px", height: "13px", borderRadius: "6px", background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)", backgroundSize: "600px 100%", animation: "shimmer 1.4s infinite linear", marginBottom: "16px" }} />
            </>
          ) : (
            <>
              <h4 style={{ color: "#0A0A0A", fontWeight: "600", fontSize: "20px" }}>EMI Behavior Tracking</h4>
              <p className="emi-behavior__month" style={{ color: "#4A5565", fontSize: "14px", fontWeight: "400" }}>
                {selectedMonth?.length > 0 ? `Month: ${selectedMonth?.join(", ")}` : "No months selected"}
              </p>
            </>
          )}
        </div>

        <div className="emi-behavior__grid">
          {loading
            ? SKELETON_COLORS.map((color, i) => (
                <div key={i} className="emi-behavior__card" style={{ background: color, borderRadius: "12px", padding: "20px" }}>
                  <SkBox w="80%" h="13px" style={{ marginBottom: "14px" }} />
                  <SkBox w="60%" h="28px" style={{ marginBottom: "10px", borderRadius: "6px" }} />
                  <SkBox w="70%" h="12px" />
                </div>
              ))
            : cards.map((card, index) => (
                <div key={index} className="emi-behavior__card" style={{ background: card.bg }}>
                  <p className="emi-behavior__card-title">{card.title}</p>
                  <h4 className="emi-behavior__card-value">{card.value}</h4>
                  <p className="emi-behavior__card-subtitle">{card.subtitle}</p>
                </div>
              ))
          }
        </div>
      </div>
    </>
  );
}